import React from 'react';

const LEGAL_BLURB =
  'PlayNation – das beste Browser-Spieleportal, auf dem man eine große Auswahl an HTML5-Spielen sofort und ohne Download spielen kann. Das Angebot umfasst beliebte Kategorien wie Match-3, Bubble Shooter, Puzzle, Quiz, Kartenspiele, Mädchenspiele, Jump & Run, Arcade, Rennspiele, Sport und Multiplayer – alle optimiert für Desktop, Tablet und Smartphone und basierend auf modernen Webstandards! Mit Bestätigung der Schaltfläche Weiter stimmen Sie den allgemeinen Geschäftsbedingungen zu. Kosten: 10CHF Sunrise/3x5CHF Swisscom&Salt pro Woche. Wenn Sie Hilfe benötigen kontaktieren Sie uns bitte indem Sie eine E-mail an playnation.ch@silverlines.info senden oder telefonisch unter 41 445816161. Zusätzliche GPRS-Gebühren können angewendet werden. Die Zusendung der MO SMS wird nach Ihrem Tarif model verrechnet. Um Ihr Abo zu kündigen, senden Sie dazu einfach eine SMS mit STOP PLAY an die 787 für Salt und Sunrise oder an die 742 für Swisscom.';

const links = [
  { label: 'Impressum', href: '/impressum.html' },
  { label: 'Hilfe', href: '/hilfe.html' },
  { label: 'AGB', href: '/agb.html' },
  { label: 'Abo Verwaltung', href: '/abo.html' },
];

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-white border-t border-slate-100 py-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <p className="text-xs text-slate-400 leading-relaxed mb-8 max-w-5xl mx-auto text-center sm:text-left">
          {LEGAL_BLURB}
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-between gap-6">
          <div className="flex flex-col items-center sm:items-start gap-1">
            <a href="/" className="flex items-center gap-0.5 select-none">
              <span className="text-xl font-black tracking-tight text-emerald-600">FitX</span>
              <span className="text-xl font-black tracking-tight text-slate-900">celerate</span>
              <span className="ml-1.5 text-sm">🇨🇭</span>
            </a>
          </div>

          <nav className="flex items-center gap-6 flex-wrap justify-center">
            {links.map((link) => (
              <a
                key={link.label}
                href={link.href}
                className="text-sm text-slate-400 hover:text-emerald-600 transition-colors duration-200"
              >
                {link.label}
              </a>
            ))}
          </nav>

          <p className="text-sm text-slate-400 whitespace-nowrap">
            © {year} FitXcelerate
          </p>
        </div>
      </div>
    </footer>
  );
}
